import { useCallback } from 'react';

import { useNavigation } from '@react-navigation/native';

import { CasinoTabNavigationProp } from '@/navigation/casino/types';

import { isNavigableCategory } from '../utils/utils';
import { useNonNavigableCategories } from './use-non-navigable-categories';

export interface LayoutHeaderProps {
    title?: string;
    categoryId?: string;
    onSelectId?: (id: string) => void;
    isLobby?: boolean;
    onScrollToTop?: () => void;
}

export const useLayoutHeaderLink = ({
    title,
    categoryId,
    onSelectId,
    isLobby = false,
    onScrollToTop,
}: LayoutHeaderProps) => {
    const navigation = useNavigation<CasinoTabNavigationProp>();
    const nonNavigableCategories = useNonNavigableCategories();

    const isNavigable = Boolean(title) && isLobby && isNavigableCategory(title ?? '', nonNavigableCategories);

    const navigate = useCallback(() => {
        if (isNavigable && title && categoryId) {
            navigation.setParams({
                category: title,
            });
            onSelectId?.(categoryId);
            onScrollToTop?.();
        }
    }, [isNavigable, title, categoryId, navigation, onSelectId, onScrollToTop]);

    return { isNavigable, navigate };
};
